import { Typography } from 'src/ui/common/atoms/typography';
import { media } from 'src/ui/common/mixins/media';
import { Button } from 'src/ui/white-labels/techcontemporary/atoms/button';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
    margin: 48px 0;
    padding: 0 16px;

    ${media.sm`
        margin: 40px auto;
        padding: 0 48px;
        max-width: 1440px;
    `}
`;

export const StyledHeading = styled(Typography)`
    padding-bottom: 24px;

    ${media.sm`
       padding-bottom: 0
    `};
`;

export const StyledTitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 15px;
    align-items: center;
    margin-top: 100px;
    margin-bottom: 24px;

    ${media.sm`
        margin-bottom: 0px;
    `}
`;

export const StyledButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 30px;

    & svg {
        margin-left: 10px;
    }
`;

export const StyledButton = styled(Button)`
    width: 100%;
    ${media.sm`
        width: 245px;
    `}
`;